import {useKeyVaultStore} from "../../api/KeyVaultStore";
import {useAuthStore} from "../../app-layout/authStore";
import {KeyVault} from "../../api/Model";
import {create} from "zustand";
import {RemoteValue} from "../../util/RemoteValue";
import {derivedStore} from "../../api/DerivedStore";
import {useCurrentOfficeStore} from "../../api/CurrentOfficeStore";
import {Access} from "../../util/access/Access";


export const useDefaultKeyVaultStore = create<{ remoteValue: RemoteValue<KeyVault> }>(
    derivedStore(
        {keyVaultStore: useKeyVaultStore, authStore: useAuthStore, currentOffice: useCurrentOfficeStore},
        ({keyVaultStore, authStore: {user}, currentOffice}) => ({
            remoteValue: keyVaultStore.remoteValue.map(keyVaults => {
                const access = new Access(user, currentOffice.officeId);
                return access.accessibleVaults.getDefaultKeyVault(keyVaults);
            })
        }),
    ));
